// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file aggregate/v1/aggregate_api.proto (package aggregate.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { User } from "../../base/v1/user_pb.js";
import { Company, CompanyUser } from "../../company/v1/company_pb.js";
import { AccessType } from "../../base/v1/access_pb.js";
import { Project } from "../../project/v1/project_pb.js";
import { Task } from "../../task/v1/task_pb.js";

/**
 * @generated from message aggregate.v1.GetUserAggregateProfileRequest
 */
export const GetUserAggregateProfileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetUserAggregateProfileRequest",
  [],
);

/**
 * @generated from message aggregate.v1.GetUserAggregateProfileResponse
 */
export const GetUserAggregateProfileResponse = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetUserAggregateProfileResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "company_access_type", kind: "enum", T: proto3.getEnumType(AccessType) },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyProjectAggregateUsersRequest
 */
export const GetCompanyProjectAggregateUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyProjectAggregateUsersRequest",
  () => [
    { no: 1, name: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyProjectAggregateUsersResponse
 */
export const GetCompanyProjectAggregateUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyProjectAggregateUsersResponse",
  () => [
    { no: 1, name: "company_users", kind: "message", T: CompanyUser, repeated: true },
    { no: 2, name: "project", kind: "message", T: Project },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyProjectsAggregateRequest
 */
export const GetCompanyProjectsAggregateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyProjectsAggregateRequest",
  () => [
    { no: 1, name: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyProjectsAggregateResponse
 */
export const GetCompanyProjectsAggregateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyProjectsAggregateResponse",
  () => [
    { no: 1, name: "company", kind: "message", T: Company },
    { no: 2, name: "projects", kind: "message", T: Project, repeated: true },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyProjectsTasksAggregateRequest
 */
export const GetCompanyProjectsTasksAggregateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyProjectsTasksAggregateRequest",
  () => [
    { no: 1, name: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyProjectsTasksAggregateResponse
 */
export const GetCompanyProjectsTasksAggregateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyProjectsTasksAggregateResponse",
  () => [
    { no: 1, name: "company_users", kind: "message", T: CompanyUser, repeated: true },
    { no: 2, name: "projects", kind: "message", T: Project, repeated: true },
    { no: 3, name: "tasks", kind: "message", T: Task, repeated: true },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyUserAndProjectsRequest
 */
export const GetCompanyUserAndProjectsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyUserAndProjectsRequest",
  () => [
    { no: 1, name: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message aggregate.v1.GetCompanyUserAndProjectsResponse
 */
export const GetCompanyUserAndProjectsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "aggregate.v1.GetCompanyUserAndProjectsResponse",
  () => [
    { no: 1, name: "company_user", kind: "message", T: CompanyUser },
    { no: 2, name: "projects", kind: "message", T: Project, repeated: true },
  ],
);

